import { enClientPortalCreateOrderPagePages } from './Orders/CreateOrder/CreateOrderPage'
import { enClientPortalOrderDetailsPagePages } from './Orders/OrderDetails/OrderDetailsPage'
import { enClientPortalTaskListPagePages } from './Orders/OrderDetails/TaskList/TaskListPage'
import { enClientPortalThreadListPagePages } from './Orders/OrderDetails/ThreadList/ThreadListPage'
import { enClientPortalOrderListPagePages } from './Orders/OrderList/OrderListPage'
import { enClientPortalOrderManagementSidebarPages } from './Orders/OrderManagementSidebar'
import { enClientPortalOrderSidebarPages } from './Orders/OrderSidebar'

export const enClientPortalOrdersPages = {
    orders: {
        ...enClientPortalOrderManagementSidebarPages.orders,
        ...enClientPortalOrderSidebarPages.orders,
        ...enClientPortalCreateOrderPagePages.orders,
        ...enClientPortalOrderListPagePages.orders,
        ...enClientPortalOrderDetailsPagePages.orders,
        ...enClientPortalTaskListPagePages.orders,
        ...enClientPortalThreadListPagePages.orders,
    },
}
